// extracted by mini-css-extract-plugin
export default {"skill_tag":"Timeline_skill_tag__MWebp","skills":"Timeline_skills__92bRq","skill_div":"Timeline_skill_div__2Co59","job_description":"Timeline_job_description__gE3no"};